interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  const fullTitle = `${title} - 韩漫漫画网`;
  const fullCanonical = `https://hanman.com${canonicalUrl}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="韩漫漫画网" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      <meta name="geo.region" content="CN-BJ" />
      <meta name="geo.placename" content="北京" />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </>
  );
}

export default SEOHead;